export default __webpack_public_path__ + "static/media/lunch5.1d06b275.jpeg";